import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import heCommon from './locales/he/common.json';
import heMarketing from './locales/he/marketing.json';
import enCommon from './locales/en/common.json';
import enMarketing from './locales/en/marketing.json';
import ruCommon from './locales/ru/common.json';
import ruMarketing from './locales/ru/marketing.json';
import arCommon from './locales/ar/common.json';
import arMarketing from './locales/ar/marketing.json';

export const RTL_LANGUAGES = ['he', 'ar'];

export const LANGUAGES = [
  { code: 'he', name: 'עברית', dir: 'rtl' as const },
  { code: 'en', name: 'English', dir: 'ltr' as const },
  { code: 'ru', name: 'Русский', dir: 'ltr' as const },
  { code: 'ar', name: 'العربية', dir: 'rtl' as const },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: { common: heCommon, marketing: heMarketing },
      en: { common: enCommon, marketing: enMarketing },
      ru: { common: ruCommon, marketing: ruMarketing },
      ar: { common: arCommon, marketing: arMarketing },
    },
    fallbackLng: 'he',
    defaultNS: 'common',
    ns: ['common', 'marketing'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'kipikid-lang',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
